import HashtagLink from './HashtagLink'
import UserLink from './UserLink'

const TextPart = ({part}) => {
  switch (part.text_type) {
    case 'hashtag':
      return <HashtagLink hashtag_id={part.hashtag} />
    case 'username':
      return <UserLink user_id={part.user_id} username={part.text} />
    default:
      return <span>{part.text}</span>
  }
}

export default TextPart
